import { isSameSearchCriteria } from "domains/publication/reducer";
import type { RootState } from "types";

export const createEventsForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.events.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, { ...getEventsSearchCriteria(state), id }),
  );

export const getEventsSearchCriteria = (state: RootState) => state.domains.events.searchCriteria;

export const getIsEventsFiltered = (state: RootState) => {
  const { search, year } = getEventsSearchCriteria(state);
  return !!search || !!year;
};

export const getEventFilterCount = (state: RootState) => {
  const { search, year } = getEventsSearchCriteria(state);
  let count = 0;
  if (search) count++;
  if (year) count++;
  return count;
};
